import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const createAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiser === undefined) {
        throw new Error('Missing required body: advertiser');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/advertisers';
    const pathInternal = '/api/proxy/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiser !== undefined) {
        body = params.advertiser;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdvertiser.paramsOrder = [{ type: 'body', paramName: 'advertiser' }, { type: 'parameters' }];
export const getActiveAdvertiserByName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserNameDto === undefined) {
        throw new Error('Missing required body: advertiserNameDto');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/advertiser/active/by-name';
    const pathInternal = '/api/proxy/advertiser/active/by-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserNameDto !== undefined) {
        body = params.advertiserNameDto;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getActiveAdvertiserByName.paramsOrder = [
    { type: 'body', paramName: 'advertiserNameDto' },
    { type: 'parameters' },
];
export const getAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/advertiser/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/advertiser/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertiser.paramsOrder = [{ type: 'parameters' }];
export const updateAdvertiser = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiser === undefined) {
        throw new Error('Missing required body: advertiser');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/advertiser/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/advertiser/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiser !== undefined) {
        body = params.advertiser;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdvertiser.paramsOrder = [{ type: 'body', paramName: 'advertiser' }, { type: 'parameters' }];
export const createProfile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.profile === undefined) {
        throw new Error('Missing required body: profile');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/profile';
    const pathInternal = '/api/proxy/profile';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.profile !== undefined) {
        body = params.profile;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createProfile.paramsOrder = [{ type: 'body', paramName: 'profile' }, { type: 'parameters' }];
/** Creates a profile owned by the member rather than an advertiser, which is what a seller-side deal targets with. Separate from createProfile so that operation keeps its parameters, and its consumers. */ export const createMemberProfile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.profile === undefined) {
        throw new Error('Missing required body: profile');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/member-profile';
    const pathInternal = '/api/proxy/member-profile';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.profile !== undefined) {
        body = params.profile;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createMemberProfile.paramsOrder = [{ type: 'body', paramName: 'profile' }, { type: 'parameters' }];
export const getProfile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/profile/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/profile/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getProfile.paramsOrder = [{ type: 'parameters' }];
export const updateProfile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.profile === undefined) {
        throw new Error('Missing required body: profile');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/profile/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/profile/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.profile !== undefined) {
        body = params.profile;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateProfile.paramsOrder = [{ type: 'body', paramName: 'profile' }, { type: 'parameters' }];
/** Used to clean up a profile whose object never got created, so a retry does not leave another one behind. Omit advertiserId for a member-level profile. */ export const deleteProfile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/profile/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/profile/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteProfile.paramsOrder = [{ type: 'parameters' }];
export const createInsertionOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.insertionOrder === undefined) {
        throw new Error('Missing required body: insertionOrder');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/insertion-order';
    const pathInternal = '/api/proxy/insertion-order';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.insertionOrder !== undefined) {
        body = params.insertionOrder;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createInsertionOrder.paramsOrder = [{ type: 'body', paramName: 'insertionOrder' }, { type: 'parameters' }];
export const getInsertionOrderByCode = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.code === undefined) {
        throw new Error('Missing required parameter: code');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/insertion-order/by-code';
    const pathInternal = '/api/proxy/insertion-order/by-code';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.code !== undefined) {
        urlParams.append('code', params.code.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInsertionOrderByCode.paramsOrder = [{ type: 'parameters' }];
export const getInsertionOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/insertion-order/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/insertion-order/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInsertionOrder.paramsOrder = [{ type: 'parameters' }];
export const updateInsertionOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.insertionOrder === undefined) {
        throw new Error('Missing required body: insertionOrder');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/insertion-order/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/insertion-order/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.insertionOrder !== undefined) {
        body = params.insertionOrder;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateInsertionOrder.paramsOrder = [{ type: 'body', paramName: 'insertionOrder' }, { type: 'parameters' }];
export const deleteInsertionOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/insertion-order/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/insertion-order/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteInsertionOrder.paramsOrder = [{ type: 'parameters' }];
export const createCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.campaign === undefined) {
        throw new Error('Missing required body: campaign');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/campaign';
    const pathInternal = '/api/proxy/campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.campaign !== undefined) {
        body = params.campaign;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaign.paramsOrder = [{ type: 'body', paramName: 'campaign' }, { type: 'parameters' }];
export const updateCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.campaign === undefined) {
        throw new Error('Missing required body: campaign');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/campaign/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/campaign/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.campaign !== undefined) {
        body = params.campaign;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaign.paramsOrder = [{ type: 'body', paramName: 'campaign' }, { type: 'parameters' }];
export const createLineItem = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lineItem === undefined) {
        throw new Error('Missing required body: lineItem');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/line-item';
    const pathInternal = '/api/proxy/line-item';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lineItem !== undefined) {
        body = params.lineItem;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createLineItem.paramsOrder = [{ type: 'body', paramName: 'lineItem' }, { type: 'parameters' }];
export const getForecastInventory = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.forecastInventoryRequest === undefined) {
        throw new Error('Missing required body: forecastInventoryRequest');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/forecast-inventory';
    const pathInternal = '/api/proxy/forecast-inventory';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forecastInventoryRequest !== undefined) {
        body = params.forecastInventoryRequest;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastInventory.paramsOrder = [
    { type: 'body', paramName: 'forecastInventoryRequest' },
    { type: 'parameters' },
];
export const getForecastContention = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.forecastContentionRequest === undefined) {
        throw new Error('Missing required body: forecastContentionRequest');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/forecast-contention';
    const pathInternal = '/api/proxy/forecast-contention';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forecastContentionRequest !== undefined) {
        body = params.forecastContentionRequest;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getForecastContention.paramsOrder = [
    { type: 'body', paramName: 'forecastContentionRequest' },
    { type: 'parameters' },
];
export const createProgrammableSplits = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lineItemId === undefined) {
        throw new Error('Missing required parameter: lineItemId');
    }
    if (params.splits === undefined) {
        throw new Error('Missing required body: splits');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/line-item/{lineItemId}/splits'.replaceAll('{lineItemId}', () => encodeURIComponent(String(params.lineItemId)));
    const pathInternal = '/api/proxy/line-item/{lineItemId}/splits'.replaceAll('{lineItemId}', () => encodeURIComponent(String(params.lineItemId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.splits !== undefined) {
        body = params.splits;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createProgrammableSplits.paramsOrder = [{ type: 'body', paramName: 'splits' }, { type: 'parameters' }];
export const getLineItem = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/line-item/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/line-item/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLineItem.paramsOrder = [{ type: 'parameters' }];
export const updateLineItem = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.lineItem === undefined) {
        throw new Error('Missing required body: lineItem');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/line-item/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/line-item/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.lineItem !== undefined) {
        body = params.lineItem;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateLineItem.paramsOrder = [{ type: 'body', paramName: 'lineItem' }, { type: 'parameters' }];
export const deleteLineItem = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.xandrId === undefined) {
        throw new Error('Missing required parameter: xandrId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/line-item/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    const pathInternal = '/api/proxy/line-item/{xandrId}'.replaceAll('{xandrId}', () => encodeURIComponent(String(params.xandrId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteLineItem.paramsOrder = [{ type: 'parameters' }];
/** Get creative by id */ export const getCreativeByIdFromApn = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeByIdFromApn.paramsOrder = [{ type: 'parameters' }];
/** Update creative */ export const updateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.creative === undefined) {
        throw new Error('Missing required body: creative');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creative !== undefined) {
        body = params.creative;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreative.paramsOrder = [{ type: 'body', paramName: 'creative' }, { type: 'parameters' }];
/** Delete creative */ export const deleteCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreative.paramsOrder = [{ type: 'parameters' }];
/** Create creative */ export const createCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creative === undefined) {
        throw new Error('Missing required body: creative');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/creatives';
    const pathInternal = '/api/proxy/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creative !== undefined) {
        body = params.creative;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCreative.paramsOrder = [{ type: 'body', paramName: 'creative' }, { type: 'parameters' }];
/** Create placement */ export const createPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.placement === undefined) {
        throw new Error('Missing required body: placement');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/placements';
    const pathInternal = '/api/proxy/placements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placement !== undefined) {
        body = params.placement;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPlacement.paramsOrder = [{ type: 'body', paramName: 'placement' }, { type: 'parameters' }];
/** Update placement */ export const updatePlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.placementId === undefined) {
        throw new Error('Missing required parameter: placementId');
    }
    if (params.placement === undefined) {
        throw new Error('Missing required body: placement');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/proxy/placements/{placementId}'.replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    const pathInternal = '/api/proxy/placements/{placementId}'.replaceAll('{placementId}', () => encodeURIComponent(String(params.placementId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placement !== undefined) {
        body = params.placement;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePlacement.paramsOrder = [{ type: 'body', paramName: 'placement' }, { type: 'parameters' }];
/** Get paginated advertisers */ export const getAdvertisers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/advertisers';
    const pathInternal = '/api/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.periodOfDays : (params.periodOfDays ?? queryDefaults?.['periodOfDays']);
        if (value !== undefined) {
            urlParams.append('periodOfDays', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertisers.paramsOrder = [{ type: 'parameters' }];
export const getInsertionOrdersPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/insertion-order';
    const pathInternal = '/api/insertion-order';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInsertionOrdersPage.paramsOrder = [{ type: 'parameters' }];
export const getLineItemsPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/line-item';
    const pathInternal = '/api/line-item';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.periodOfDays : (params.periodOfDays ?? queryDefaults?.['periodOfDays']);
        if (value !== undefined) {
            urlParams.append('periodOfDays', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLineItemsPage.paramsOrder = [{ type: 'parameters' }];
export const getLineItemsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/line-item/by-ids';
    const pathInternal = '/api/line-item/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLineItemsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const cleanupLineItemByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/line-item/by-ids';
    const pathInternal = '/api/line-item/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
cleanupLineItemByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }, { type: 'parameters' }];
/** activate line items */ export const activateLineItems = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lineItemIds === undefined) {
        throw new Error('Missing required body: lineItemIds');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/line-item/activate';
    const pathInternal = '/api/line-item/activate';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lineItemIds !== undefined) {
        body = params.lineItemIds;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
activateLineItems.paramsOrder = [{ type: 'body', paramName: 'lineItemIds' }, { type: 'parameters' }];
/** deactivate line items */ export const deactivateLineItems = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lineItemIds === undefined) {
        throw new Error('Missing required body: lineItemIds');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/line-item/deactivate';
    const pathInternal = '/api/line-item/deactivate';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lineItemIds !== undefined) {
        body = params.lineItemIds;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deactivateLineItems.paramsOrder = [{ type: 'body', paramName: 'lineItemIds' }, { type: 'parameters' }];
/** Get paginated line item creatives */ export const getLineItemCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/line-item-creatives';
    const pathInternal = '/api/line-item-creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLineItemCreatives.paramsOrder = [{ type: 'parameters' }];
export const getCreativesCompaniesMapping = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/creatives/companies/mapping';
    const pathInternal = '/api/creatives/companies/mapping';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesCompaniesMapping.paramsOrder = [];
export const getMediationExcludedCreatives = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/creatives/mediation-excluded';
    const pathInternal = '/api/creatives/mediation-excluded';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMediationExcludedCreatives.paramsOrder = [];
/** Get paginated creatives */ export const getCreativesPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.periodOfDays : (params.periodOfDays ?? queryDefaults?.['periodOfDays']);
        if (value !== undefined) {
            urlParams.append('periodOfDays', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.state : (params.state ?? queryDefaults?.['state']);
        if (value !== undefined) {
            urlParams.append('state', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.type : (params.type ?? queryDefaults?.['type']);
        if (value !== undefined) {
            urlParams.append('type', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.advertiserId : (params.advertiserId ?? queryDefaults?.['advertiserId']);
        if (value !== undefined) {
            urlParams.append('advertiserId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesPage.paramsOrder = [{ type: 'parameters' }];
/** Create native media asset */ export const createNativeImageMediaAsset = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.imageForm === undefined) {
        throw new Error('Missing required body: imageForm');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/media-assets/native';
    const pathInternal = '/api/creatives/media-assets/native';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.imageForm !== undefined) {
        body = params.imageForm;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createNativeImageMediaAsset.paramsOrder = [{ type: 'body', paramName: 'imageForm' }, { type: 'parameters' }];
/** Create video media asset */ export const createVideoMediaAsset = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.videoForm === undefined) {
        throw new Error('Missing required body: videoForm');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/media-assets/video';
    const pathInternal = '/api/creatives/media-assets/video';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.videoForm !== undefined) {
        body = params.videoForm;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createVideoMediaAsset.paramsOrder = [{ type: 'body', paramName: 'videoForm' }, { type: 'parameters' }];
/** Get creative by id */ export const getCreativeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/creatives/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeById.paramsOrder = [{ type: 'parameters' }];
/** Get creative preview by id */ export const getCreativePreviewById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/{creativeId}/preview'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/creatives/{creativeId}/preview'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativePreviewById.paramsOrder = [{ type: 'parameters' }];
export const getCreativesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/creatives/by-ids';
    const pathInternal = '/api/creatives/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getCreativesStatesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/creatives/state';
    const pathInternal = '/api/creatives/state';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesStatesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const restoreCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/restore/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/creatives/restore/{creativeId}'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreCreative.paramsOrder = [{ type: 'parameters' }];
export const getCreativeTemplates = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/creatives/templates';
    const pathInternal = '/api/creatives/templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameContains : (params.nameContains ?? queryDefaults?.['nameContains']);
        if (value !== undefined) {
            urlParams.append('nameContains', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.mediaSubtypeId : (params.mediaSubtypeId ?? queryDefaults?.['mediaSubtypeId']);
        if (value !== undefined) {
            urlParams.append('mediaSubtypeId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.formatId : (params.formatId ?? queryDefaults?.['formatId']);
        if (value !== undefined) {
            urlParams.append('formatId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.managedBy : (params.managedBy ?? queryDefaults?.['managedBy']);
        if (value !== undefined) {
            urlParams.append('managedBy', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeTemplates.paramsOrder = [{ type: 'parameters' }];
export const createCreativeTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/templates';
    const pathInternal = '/api/creatives/templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCreativeTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }, { type: 'parameters' }];
export const getCreativeTemplateById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.templateId === undefined) {
        throw new Error('Missing required parameter: templateId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/templates/{templateId}'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    const pathInternal = '/api/creatives/templates/{templateId}'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeTemplateById.paramsOrder = [{ type: 'parameters' }];
export const updateCreativeTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.templateId === undefined) {
        throw new Error('Missing required parameter: templateId');
    }
    if (params.template === undefined) {
        throw new Error('Missing required body: template');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/templates/{templateId}'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    const pathInternal = '/api/creatives/templates/{templateId}'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.template !== undefined) {
        body = params.template;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativeTemplate.paramsOrder = [{ type: 'body', paramName: 'template' }, { type: 'parameters' }];
export const updateCreativeTemplateState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.templateId === undefined) {
        throw new Error('Missing required parameter: templateId');
    }
    if (params.state === undefined) {
        throw new Error('Missing required body: state');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/templates/{templateId}/state'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    const pathInternal = '/api/creatives/templates/{templateId}/state'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.state !== undefined) {
        body = params.state;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativeTemplateState.paramsOrder = [{ type: 'body', paramName: 'state' }, { type: 'parameters' }];
export const cloneCreativeTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.templateId === undefined) {
        throw new Error('Missing required parameter: templateId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/templates/{templateId}/clone'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    const pathInternal = '/api/creatives/templates/{templateId}/clone'.replaceAll('{templateId}', () => encodeURIComponent(String(params.templateId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCreativeTemplate.paramsOrder = [{ type: 'parameters' }];
export const getCreativeMediaTypes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/creatives/media-types';
    const pathInternal = '/api/creatives/media-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativeMediaTypes.paramsOrder = [];
/** Check and replace creative macros in content/url */ export const creativeMacroCheck = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-appnexus-proxy/creatives/creative-macro-check';
    const pathInternal = '/api/creatives/creative-macro-check';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
creativeMacroCheck.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Check if native video creative assets are validated in Xandr */ export const checkAssetValidationStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/{creativeId}/asset-validation-status'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/creatives/{creativeId}/asset-validation-status'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkAssetValidationStatus.paramsOrder = [{ type: 'parameters' }];
/** Activate a creative in Xandr by setting its state to active */ export const activateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/creatives/{creativeId}/activate'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    const pathInternal = '/api/creatives/{creativeId}/activate'.replaceAll('{creativeId}', () => encodeURIComponent(String(params.creativeId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
activateCreative.paramsOrder = [{ type: 'parameters' }];
export const getMembersPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/member';
    const pathInternal = '/api/member';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterHasNotMemberId
            : (params.filterHasNotMemberId ?? queryDefaults?.['filterHasNotMemberId']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('filterHasNotMemberId', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterContainsName
            : (params.filterContainsName ?? queryDefaults?.['filterContainsName']);
        if (value !== undefined) {
            urlParams.append('filterContainsName', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMembersPage.paramsOrder = [{ type: 'parameters' }];
export const getMember = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-appnexus-proxy/member/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/member/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMember.paramsOrder = [{ type: 'parameters' }];
export const getDealsReports = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/deal-reports';
    const pathInternal = '/api/deal-reports';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDealsReports.paramsOrder = [{ type: 'parameters' }];
export const getDealsPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/deal';
    const pathInternal = '/api/deal';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterHasBuyerId
            : (params.filterHasBuyerId ?? queryDefaults?.['filterHasBuyerId']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('filterHasBuyerId', item.toString()));
        }
    }
    {
        const value = queryDefaults === false ? params.filterHasDealId : (params.filterHasDealId ?? queryDefaults?.['filterHasDealId']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('filterHasDealId', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterHasNotBuyerId
            : (params.filterHasNotBuyerId ?? queryDefaults?.['filterHasNotBuyerId']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('filterHasNotBuyerId', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterHasNotDealId
            : (params.filterHasNotDealId ?? queryDefaults?.['filterHasNotDealId']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('filterHasNotDealId', item.toString()));
        }
    }
    {
        const value = queryDefaults === false
            ? params.filterContainsName
            : (params.filterContainsName ?? queryDefaults?.['filterContainsName']);
        if (value !== undefined) {
            urlParams.append('filterContainsName', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDealsPage.paramsOrder = [{ type: 'parameters' }];
/** Creates a seller-side deal in Xandr. Creation only - Xandr deals are never updated from here. */ export const createDeal = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.deal === undefined) {
        throw new Error('Missing required body: deal');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/deal';
    const pathInternal = '/api/deal';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.deal !== undefined) {
        body = params.deal;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDeal.paramsOrder = [{ type: 'body', paramName: 'deal' }, { type: 'parameters' }];
export const getDeal = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-appnexus-proxy/deal/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/deal/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeal.paramsOrder = [{ type: 'parameters' }];
export const getPublishersPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/publisher';
    const pathInternal = '/api/publisher';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isActive : (params.isActive ?? queryDefaults?.['isActive']);
        if (value !== undefined) {
            urlParams.append('isActive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublishersPage.paramsOrder = [{ type: 'parameters' }];
export const getPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-appnexus-proxy/publisher/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/publisher/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisher.paramsOrder = [{ type: 'parameters' }];
export const getPublisherIds = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/publisher/all-ids';
    const pathInternal = '/api/publisher/all-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherIds.paramsOrder = [];
export const getPublishersByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/publisher/by-ids';
    const pathInternal = '/api/publisher/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublishersByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getPublisherIdsByContentCategoryIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contentCategoryIds === undefined) {
        throw new Error('Missing required body: contentCategoryIds');
    }
    const path = '/api/ws-appnexus-proxy/publisher-ids/by-content-category-ids';
    const pathInternal = '/api/publisher-ids/by-content-category-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contentCategoryIds !== undefined) {
        body = params.contentCategoryIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherIdsByContentCategoryIds.paramsOrder = [{ type: 'body', paramName: 'contentCategoryIds' }];
export const getSitesPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/site';
    const pathInternal = '/api/site';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSitesPage.paramsOrder = [{ type: 'parameters' }];
export const getSite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-appnexus-proxy/site/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/site/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSite.paramsOrder = [{ type: 'parameters' }];
export const getSitesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/site/by-ids';
    const pathInternal = '/api/site/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSitesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getPlacementsPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/placement';
    const pathInternal = '/api/placement';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementsPage.paramsOrder = [{ type: 'parameters' }];
export const getPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-appnexus-proxy/placement/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/placement/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacement.paramsOrder = [{ type: 'parameters' }];
export const getPlacementsByDomain = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.domain === undefined) {
        throw new Error('Missing required parameter: domain');
    }
    const path = '/api/ws-appnexus-proxy/placement/by-domain';
    const pathInternal = '/api/placement/by-domain';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.domain !== undefined) {
        urlParams.append('domain', params.domain.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementsByDomain.paramsOrder = [{ type: 'parameters' }];
export const getPlacementsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/placement/by-ids';
    const pathInternal = '/api/placement/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacementsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getAllPublisherBrands = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/publisher/brands/all';
    const pathInternal = '/api/publisher/brands/all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllPublisherBrands.paramsOrder = [{ type: 'parameters' }];
export const getPublisherBrandsByPublisherIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publisherIds === undefined) {
        throw new Error('Missing required parameter: publisherIds');
    }
    const path = '/api/ws-appnexus-proxy/publisher/brands/by-publisher-ids';
    const pathInternal = '/api/publisher/brands/by-publisher-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.publisherIds !== undefined) {
        urlParams.append('publisherIds', params.publisherIds.toString());
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublisherBrandsByPublisherIds.paramsOrder = [{ type: 'parameters' }];
export const getAllBrandPublishers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/brand/publishers/all';
    const pathInternal = '/api/brand/publishers/all';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllBrandPublishers.paramsOrder = [{ type: 'parameters' }];
export const getPublishersByBrandId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-appnexus-proxy/brand/{id}/publishers'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/brand/{id}/publishers'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPublishersByBrandId.paramsOrder = [{ type: 'parameters' }];
export const getBrandPublishersByPublisherIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.publisherIds === undefined) {
        throw new Error('Missing required parameter: publisherIds');
    }
    const path = '/api/ws-appnexus-proxy/brand/publishers/by-publisher-ids';
    const pathInternal = '/api/brand/publishers/by-publisher-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.publisherIds !== undefined) {
        urlParams.append('publisherIds', params.publisherIds.toString());
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBrandPublishersByPublisherIds.paramsOrder = [{ type: 'parameters' }];
/** Get paginated regions */ export const getPaginatedRegions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/regions';
    const pathInternal = '/api/regions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedRegions.paramsOrder = [{ type: 'parameters' }];
/** Get available countries */ export const getCountries = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/countries';
    const pathInternal = '/api/countries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCountries.paramsOrder = [];
/** Get regions by region ids */ export const getRegionsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/regions/by-ids';
    const pathInternal = '/api/regions/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRegionsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
/** Get regions by country ids */ export const getRegionsByCountryIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.countryIds === undefined) {
        throw new Error('Missing required body: countryIds');
    }
    const path = '/api/ws-appnexus-proxy/regions/by-country-ids';
    const pathInternal = '/api/regions/by-country-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.countryIds !== undefined) {
        body = params.countryIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRegionsByCountryIds.paramsOrder = [{ type: 'body', paramName: 'countryIds' }];
/** Get paginated postal codes */ export const getPaginatedPostalCodes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/postal-codes';
    const pathInternal = '/api/postal-codes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedPostalCodes.paramsOrder = [{ type: 'parameters' }];
/** Get postal codes */ export const getPostalCodes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.codes === undefined) {
        throw new Error('Missing required body: codes');
    }
    const path = '/api/ws-appnexus-proxy/postal-codes';
    const pathInternal = '/api/postal-codes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.codes !== undefined) {
        body = params.codes;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostalCodes.paramsOrder = [{ type: 'body', paramName: 'codes' }];
export const getDataProviders = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/data-providers';
    const pathInternal = '/api/data-providers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDataProviders.paramsOrder = [{ type: 'parameters' }];
export const getSegmentsPage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/segment';
    const pathInternal = '/api/segment';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.seatId : (params.seatId ?? queryDefaults?.['seatId']);
        if (value !== undefined) {
            urlParams.append('seatId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.type : (params.type ?? queryDefaults?.['type']);
        if (value !== undefined) {
            urlParams.append('type', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dataProviderId : (params.dataProviderId ?? queryDefaults?.['dataProviderId']);
        if (value !== undefined) {
            urlParams.append('dataProviderId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeDisabled : (params.includeDisabled ?? queryDefaults?.['includeDisabled']);
        if (value !== undefined) {
            urlParams.append('includeDisabled', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSegmentsPage.paramsOrder = [{ type: 'parameters' }];
export const createSegment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    if (params.segment === undefined) {
        throw new Error('Missing required body: segment');
    }
    const path = '/api/ws-appnexus-proxy/segment';
    const pathInternal = '/api/segment';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    if (params.segment !== undefined) {
        body = params.segment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSegment.paramsOrder = [{ type: 'body', paramName: 'segment' }, { type: 'parameters' }];
export const getSegmentsForCurrentCompany = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/segment-for-company';
    const pathInternal = '/api/segment-for-company';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSegmentsForCurrentCompany.paramsOrder = [{ type: 'parameters' }];
export const getSegmentsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/segment-by-ids';
    const pathInternal = '/api/segment-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSegmentsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const uploadSegments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    const path = '/api/ws-appnexus-proxy/segment/batch';
    const pathInternal = '/api/segment/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'form-data',
    });
};
uploadSegments.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getSegment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    if (params.segmentId === undefined) {
        throw new Error('Missing required parameter: segmentId');
    }
    const path = '/api/ws-appnexus-proxy/segment/{segmentId}'.replaceAll('{segmentId}', () => encodeURIComponent(String(params.segmentId)));
    const pathInternal = '/api/segment/{segmentId}'.replaceAll('{segmentId}', () => encodeURIComponent(String(params.segmentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSegment.paramsOrder = [{ type: 'parameters' }];
export const updateSegmentEnabled = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    if (params.segmentId === undefined) {
        throw new Error('Missing required parameter: segmentId');
    }
    if (params.enabled === undefined) {
        throw new Error('Missing required parameter: enabled');
    }
    const path = '/api/ws-appnexus-proxy/segment/{segmentId}'.replaceAll('{segmentId}', () => encodeURIComponent(String(params.segmentId)));
    const pathInternal = '/api/segment/{segmentId}'.replaceAll('{segmentId}', () => encodeURIComponent(String(params.segmentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    if (params.enabled !== undefined) {
        urlParams.append('enabled', params.enabled.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSegmentEnabled.paramsOrder = [{ type: 'parameters' }];
export const getSegmentTaxonomy = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    if (params.segmentId === undefined) {
        throw new Error('Missing required parameter: segmentId');
    }
    const path = '/api/ws-appnexus-proxy/segment/{segmentId}/category'.replaceAll('{segmentId}', () => encodeURIComponent(String(params.segmentId)));
    const pathInternal = '/api/segment/{segmentId}/category'.replaceAll('{segmentId}', () => encodeURIComponent(String(params.segmentId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSegmentTaxonomy.paramsOrder = [{ type: 'parameters' }];
export const getTaxonomyCategories = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    const path = '/api/ws-appnexus-proxy/taxonomy/category';
    const pathInternal = '/api/taxonomy/category';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaxonomyCategories.paramsOrder = [{ type: 'parameters' }];
export const createTaxonomyCategoryMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    if (params.mapping === undefined) {
        throw new Error('Missing required body: mapping');
    }
    const path = '/api/ws-appnexus-proxy/taxonomy/category/{id}/mapping'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/taxonomy/category/{id}/mapping'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    if (params.mapping !== undefined) {
        body = params.mapping;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTaxonomyCategoryMapping.paramsOrder = [{ type: 'body', paramName: 'mapping' }, { type: 'parameters' }];
export const deleteTaxonomyCategoryMapping = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.mappingId === undefined) {
        throw new Error('Missing required parameter: mappingId');
    }
    if (params.seatId === undefined) {
        throw new Error('Missing required parameter: seatId');
    }
    const path = '/api/ws-appnexus-proxy/taxonomy/category/{id}/mapping/{mappingId}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{mappingId}', () => encodeURIComponent(String(params.mappingId)));
    const pathInternal = '/api/taxonomy/category/{id}/mapping/{mappingId}'
        .replaceAll('{id}', () => encodeURIComponent(String(params.id)))
        .replaceAll('{mappingId}', () => encodeURIComponent(String(params.mappingId)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seatId !== undefined) {
        urlParams.append('seatId', params.seatId.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTaxonomyCategoryMapping.paramsOrder = [{ type: 'parameters' }];
export const getSeatByCompanyId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/seat/by-company';
    const pathInternal = '/api/seat/by-company';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSeatByCompanyId.paramsOrder = [{ type: 'parameters' }];
export const listAvailableSeats = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/seat';
    const pathInternal = '/api/seat';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
listAvailableSeats.paramsOrder = [];
export const createSeat = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.seat === undefined) {
        throw new Error('Missing required body: seat');
    }
    const path = '/api/ws-appnexus-proxy/seat';
    const pathInternal = '/api/seat';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seat !== undefined) {
        body = params.seat;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSeat.paramsOrder = [{ type: 'body', paramName: 'seat' }];
export const updateSeat = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.seat === undefined) {
        throw new Error('Missing required body: seat');
    }
    const path = '/api/ws-appnexus-proxy/seat/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    const pathInternal = '/api/seat/{id}'.replaceAll('{id}', () => encodeURIComponent(String(params.id)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.seat !== undefined) {
        body = params.seat;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSeat.paramsOrder = [{ type: 'body', paramName: 'seat' }, { type: 'parameters' }];
export const getDeliveryDataPerPublisher = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/delivery-data-per-publisher';
    const pathInternal = '/api/delivery-data-per-publisher';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerPublisher.paramsOrder = [{ type: 'parameters' }];
export const getDeliveryDataPerSize = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lineItemIds === undefined) {
        throw new Error('Missing required body: lineItemIds');
    }
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/delivery-data-per-size';
    const pathInternal = '/api/delivery-data-per-size';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lineItemIds !== undefined) {
        body = params.lineItemIds;
    }
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerSize.paramsOrder = [{ type: 'body', paramName: 'lineItemIds' }, { type: 'parameters' }];
export const getDeliveryDataPerCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/delivery-data-per-creative';
    const pathInternal = '/api/delivery-data-per-creative';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerCreative.paramsOrder = [{ type: 'parameters' }];
export const getDeliveryDataPerSiteDomain = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/delivery-data-per-site-domain';
    const pathInternal = '/api/delivery-data-per-site-domain';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerSiteDomain.paramsOrder = [{ type: 'parameters' }];
export const getDeliveryDataPerSiteDomainPerDay = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/delivery-data-per-site-domain/per-day';
    const pathInternal = '/api/delivery-data-per-site-domain/per-day';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerSiteDomainPerDay.paramsOrder = [{ type: 'parameters' }];
export const getSspDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/ssp-delivery-data';
    const pathInternal = '/api/ssp-delivery-data';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSspDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const getRawMediaTypePlacementDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/raw-delivery-data/media-type-placement';
    const pathInternal = '/api/raw-delivery-data/media-type-placement';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRawMediaTypePlacementDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const getRawPlacementLineItemCountryDeviceDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/raw-delivery-data/placement-line-item-country-device';
    const pathInternal = '/api/raw-delivery-data/placement-line-item-country-device';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRawPlacementLineItemCountryDeviceDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const getRawPlacementCreativeDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/raw-delivery-data/placement-creative';
    const pathInternal = '/api/raw-delivery-data/placement-creative';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRawPlacementCreativeDeliveryData.paramsOrder = [{ type: 'parameters' }];
export const getCurrencyConversions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.day === undefined) {
        throw new Error('Missing required parameter: day');
    }
    const path = '/api/ws-appnexus-proxy/currency-conversion/{day}'.replaceAll('{day}', () => encodeURIComponent(String(params.day)));
    const pathInternal = '/api/currency-conversion/{day}'.replaceAll('{day}', () => encodeURIComponent(String(params.day)));
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCurrencyConversions.paramsOrder = [{ type: 'parameters' }];
/** Get paginated languages */ export const getPaginatedLanguages = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/languages';
    const pathInternal = '/api/languages';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.size : (params.size ?? queryDefaults?.['size']);
        if (value !== undefined) {
            urlParams.append('size', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            value.forEach((item) => urlParams.append('sort', item.toString()));
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedLanguages.paramsOrder = [{ type: 'parameters' }];
/** Get languages by language ids */ export const getLanguagesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-appnexus-proxy/languages/by-ids';
    const pathInternal = '/api/languages/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLanguagesByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
/** adds line item id based on creative id */ export const enrichEventWithLineItem = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/enrich';
    const pathInternal = '/api/enrich';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.eventBody !== undefined) {
        body = params.eventBody;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
enrichEventWithLineItem.paramsOrder = [{ type: 'body', paramName: 'eventBody' }];
export const getDeliveryDataPerDevice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.startDate === undefined) {
        throw new Error('Missing required parameter: startDate');
    }
    if (params.endDate === undefined) {
        throw new Error('Missing required parameter: endDate');
    }
    const path = '/api/ws-appnexus-proxy/devices';
    const pathInternal = '/api/devices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.startDate !== undefined) {
        urlParams.append('startDate', params.startDate.toString());
    }
    if (params.endDate !== undefined) {
        urlParams.append('endDate', params.endDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDataPerDevice.paramsOrder = [{ type: 'parameters' }];
export const createConversionPixel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.profile === undefined) {
        throw new Error('Missing required body: profile');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/conversion/pixel';
    const pathInternal = '/api/conversion/pixel';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.profile !== undefined) {
        body = params.profile;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createConversionPixel.paramsOrder = [{ type: 'body', paramName: 'profile' }, { type: 'parameters' }];
export const updateConversionPixel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.pixelId === undefined) {
        throw new Error('Missing required parameter: pixelId');
    }
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    if (params.profile === undefined) {
        throw new Error('Missing required body: profile');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-appnexus-proxy/conversion/pixel';
    const pathInternal = '/api/conversion/pixel';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.pixelId !== undefined) {
        urlParams.append('pixelId', params.pixelId.toString());
    }
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    if (params.profile !== undefined) {
        body = params.profile;
    }
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateConversionPixel.paramsOrder = [{ type: 'body', paramName: 'profile' }, { type: 'parameters' }];
export const getConversionPixels = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-appnexus-proxy/conversion/pixel/paginated';
    const pathInternal = '/api/conversion/pixel/paginated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getConversionPixels.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
